import { FunctionalComponent, h } from '@stencil/core';
import { AppLink, AppMedia } from './';
import get from 'lodash/get'


interface SectionHero {
    __component?: string;
    data?: any;
}

export const SectionHero: FunctionalComponent<SectionHero> = ({ data }) => {

    const { Title, Subtitle, Media, CTA1, CTA2 } = data;

    return (
        <section class="uk-container uk-container-xlarge">
            <div class="uk-width-1-1 uk-cover-container uk-position-relative wsio-hero-height">
                <AppMedia className='wsio-sepia-image wsio-dark-image' media={Media} cover eager size="(max-width: 638px) 90vh, (max-width: 958px) 100vw, 100vw" />
                <div class="uk-width-1-1 uk-position-bottom uk-padding-small uk-padding-large@s uk-background-slash">
                    <div class="uk-width-2-3@m uk-width-3-5@l uk-width-2-5@xl uk-light">
                        <div hidden={!Subtitle} class="uk-heading-medium wsio-gold uk-margin-remove-bottom">{Subtitle}</div>
                        <h1 class="uk-heading-xlarge uk-margin-remove">{Title}</h1>
                        <div class="uk-flex@m uk-margin-top">
                            <AppLink data={CTA1} className="uk-position-relative uk-button uk-button-text wsio-text-shadow" />
                        </div>
                    </div>
                    {
                        CTA2 &&
                        <div class="uk-visible@s uk-position-bottom-right">
                            <div class='wsio-button-secondary-angle uk-position-relative@ns uk-width-1-1@ns uk-padding-left uk-padding-right uk-padding-small@ns uk-width-1-1@ns uk-background-default uk-transition-toggle uk-display-inline-block'>
                                <AppLink data={CTA2} className='wsio-button-secondary uk-position-relative uk-heading-small uk-padding-left-small uk-flex uk-flex-center@s uk-flex-middle uk-button uk-button-link uk-link-primary'>{get(CTA2, 'Label')}<span class="bounce" uk-icon="icon:chevron-double-right;ratio:1.8"></span></AppLink>
                            </div>
                        </div>
                    }
                </div>
            </div>
        </section>
    )
};

